import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "asCookieConsent",
  "data-cy": "cookieConsent"
}
const _hoisted_2 = { class: "asCookieConsent_wrapper" }
const _hoisted_3 = { class: "asCookieConsent_text" }
const _hoisted_4 = ["href"]

import AcButton from '@ui-kit/components/AcButton.vue'
import getBaseUrl from '@web/common/getBaseUrl'
import { useCookieConsent } from '@web/platform.v3/composables/useCookieConsent'


export default /*@__PURE__*/_defineComponent({
  __name: 'CookieConsent',
  setup(__props) {

const { isVisible, accept } = useCookieConsent()

const policyLink = getBaseUrl('/docs/personal_data.pdf')

return (_ctx: any,_cache: any) => {
  return (_unref(isVisible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('cookieConsent.text')) + " ", 1),
            _createElementVNode("a", {
              class: "asCookieConsent_link",
              "data-cy": "cookieConsent_policyLink",
              href: _unref(policyLink),
              target: "_blank",
              rel: "noopener noreferrer"
            }, _toDisplayString(_ctx.$t('cookieConsent.policy')), 9, _hoisted_4),
            _cache[0] || (_cache[0] = _createTextVNode(". ", -1))
          ]),
          _createVNode(AcButton, {
            class: "asCookieConsent_button",
            type: "button",
            "data-cy": "cookieConsent_accept",
            onClick: _unref(accept)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cookieConsent.accept')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})